import { createStore, applyMiddleware } from "@reduxjs/toolkit";
import thunk from "redux-thunk";
//import logger from "redux-logger";
import rootReducer from "./reducers";
import { persistReducer } from "redux-persist";
import LocalStorage from "redux-persist/lib/storage";

const presistBlacklist = [
  "dispatchOrders",
  "failedOrders",
  "pendingOrders",
  "queuedOrders",
  "promotionCodes",
  "PromotionCodesSymbolsReducer",
  "ReferralCodesSymbolsReducer",
  "getCollectionTime",
];

const persistConfig = {
  key: "root",
  storage: LocalStorage,
  blacklist: presistBlacklist,
};
const persistedReducer = persistReducer(persistConfig, rootReducer);

//export default createStore(persistedReducer, applyMiddleware(thunk, logger)); // UAT logger should be removed when switching to production mode
export default createStore(persistedReducer, applyMiddleware(thunk)); // PROD
